if (current_template !== 'cart') {
  /*! modernizr 3.6.0 (Custom Build) | MIT * !*/
  // Modernizr code unchanged...
  
  // Create the observer with a more careful approach
  const uLTS = new MutationObserver(mutations => {
    // Process in batches to avoid excessive reflows
    const elementsToProcess = [];
    
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach(node => {
        // Check if this is a node we want to modify
        if (node.nodeType === 1) {  // Element node
          // Skip if the node has already been processed
          if (node.hasAttribute('data-lazy-processed')) return;
          
          // Mark this node to avoid re-processing
          node.setAttribute('data-lazy-processed', 'true');
          
          if (node.tagName === 'IFRAME' && 
              (node.src.includes("youtube.com") || node.src.includes("vimeo.com"))) {
            node.setAttribute('loading', 'lazy');
            node.setAttribute('data-src', node.src);
            node.removeAttribute('src');
          } else if (node.tagName === 'SCRIPT') {
            // Script handling logic...
            // Rest of your script processing...
          }
        }
      });
    });
  });
  
  // Start observing with more specific options
  uLTS.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
} else {
  // No need for an empty observer in the else case
  // Just don't set up the observer at all
}